// extracted by mini-css-extract-plugin
export default {"main":"Masters_main__To3N5"};